import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { AgendaData, SessionData } from "../interface";

const UpdateEventPostPublishApi = createApi({
  reducerPath: "UpdateEventPostPublishApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    updateAgenda: builder.mutation({
      query: ({
        eventId,
        agendaId,
        body
      }: {
        eventId: string | undefined;
        agendaId: string | undefined;
        body: any;
      }) => ({
        url: `/admin/${eventId}/meta/AGENDA/${agendaId}`,
        method: "POST",
        body: body
      }),
      extraOptions: { service: "TMS" }
    }),
    updateSession: builder.mutation({
      query: ({
        eventId,
        sessionId,
        body
      }: {
        eventId: string | undefined;
        sessionId: string | undefined;
        body: any;
      }) => ({
        url: `/admin/${eventId}/meta/SESSION/${sessionId}`,
        method: "POST",
        body: body
      }),
      extraOptions: { service: "TMS" }
    }),
    updateEvent: builder.mutation({
      query: ({
        eventId,
        body
      }: {
        eventId: string | undefined;
        body: any;
      }) => ({
        url: `/admin/meta/${eventId}`,
        method: "POST",
        body: body
      }),
      extraOptions: { service: "TMS" }
    })
  })
});

export const {
  useUpdateAgendaMutation,
  useUpdateSessionMutation,
  useUpdateEventMutation
} = UpdateEventPostPublishApi;

export default UpdateEventPostPublishApi;
